import { Link } from "react-router-dom";
import { scrollToId } from "../lib/scroll";

export const Footer = () => (
  <footer data-testid="footer" className="border-t-2 border-white/20 bg-black text-white">
    <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-16 md:px-10 md:pt-24">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <div className="text-4xl font-extrabold tracking-tighter md:text-6xl">Qwiri.ai</div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/55 md:text-base">
            Organizational intelligence for confident decisions. Search tells you where something is
            written. Qwiri tells you what is true — and it knows your company better every month.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/50">Explore</div>
          <div className="mt-4 flex flex-col items-start gap-3">
            {[
              ["problem", "The problem"],
              ["loop", "The loop"],
              ["product", "The product"],
              ["org-iq", "Organization IQ"],
              ["levels", "The ladder"],
              ["integrations", "Integrations"],
            ].map(([id, label]) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToId(id)}
                className="text-sm font-semibold text-white/70 transition-colors duration-150 hover:text-white"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/50">Start</div>
          <div className="mt-4 flex flex-col items-start gap-3">
            <button
              data-testid="footer-book-demo-btn"
              onClick={() => scrollToId("demo")}
              className="text-sm font-semibold text-white/70 transition-colors duration-150 hover:text-white"
            >
              Book a demo
            </button>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="text-sm font-semibold text-white/40 transition-colors duration-150 hover:text-white"
            >
              Demo requests
            </Link>
          </div>
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-3 border-t border-white/15 pt-6 text-[11px] font-bold uppercase tracking-[0.2em] text-white/40 md:flex-row md:items-center md:justify-between">
        <span>© 2026 Qwiri.ai</span>
        <span>Cite or stay silent</span>
        <span>Attribution yes · Evaluation no</span>
      </div>
    </div>
  </footer>
);
